import { Compass, Lock, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { useSiteCopy } from "../i18n/useSiteCopy.ts";
import { useDocumentTitle } from "../routing.ts";
import { ButtonLink } from "../ui/Button.tsx";

const MessagePage = ({
  icon: Icon,
  title,
  body,
  back,
}: {
  icon: LucideIcon;
  title: string;
  body: string;
  back: string;
}): ReactNode => {
  useDocumentTitle(title);
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center gap-4 px-4 py-20 text-center">
      <Icon aria-hidden="true" className="size-12 text-primary" />
      <h1 className="text-4xl font-semibold">{title}</h1>
      <p className="text-muted-foreground">{body}</p>
      <ButtonLink to="/" className="mt-2">
        {back}
      </ButtonLink>
    </div>
  );
};

export const NotFoundPage = (): ReactNode => {
  const copy = useSiteCopy().notFound;
  return <MessagePage icon={Compass} title={copy.title} body={copy.body} back={copy.back} />;
};

/** Signed in, but the role is too low; `body` says who the page is for. */
export const NoAccessPage = ({ body }: { body: string }): ReactNode => {
  const copy = useSiteCopy().noAccess;
  return <MessagePage icon={Lock} title={copy.title} body={body} back={copy.back} />;
};
